import React from 'react';

import { PrivateLayout } from '#coreComponents/Layout';

const LegacyAppLayout: React.FC<{}> = ({ children }) => (
  <PrivateLayout
    contentWrapperProps={{
      mt: [16, 16, 16, 0],
      px: 0,
      py: 0,
    }}
  >
    {children}
  </PrivateLayout>
);

export default LegacyAppLayout;
